import { render, staticRenderFns } from "./MaximizeIcon.vue?vue&type=template&id=853d5ba4&"
import script from "./MaximizeIcon.vue?vue&type=script&lang=js&"
export * from "./MaximizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports